import Rewards from "./Rewards";
const routes = [...Rewards];

export default routes;
